/**
 * 学段标签组件
 * 显示学段信息：🔴 高中 · 高考 / 🔵 初中 · 中考
 */

import React from 'react';

interface EducationLevelBadgeProps {
  educationLevel?: 'senior' | 'junior';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5',
};

export function EducationLevelBadge({
  educationLevel = 'senior',
  size = 'md',
  className = '',
}: EducationLevelBadgeProps) {
  const isSenior = educationLevel === 'senior';

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-medium rounded-full whitespace-nowrap
        ${isSenior
          ? 'bg-red-50 text-red-700 border border-red-200'
          : 'bg-blue-50 text-blue-700 border border-blue-200'
        }
        ${sizeClasses[size]}
        ${className}
      `}
    >
      <span className="text-sm leading-none">{isSenior ? '🔴' : '🔵'}</span>
      <span>{isSenior ? '高中 · 高考' : '初中 · 中考'}</span>
    </span>
  );
}

export default EducationLevelBadge;
